export default __webpack_public_path__ + "_/_/public/files/BF_Expert_Search_guide_2018_english.pdf";